import React from "react";
import { useState } from "react";

const Comp10 = (props) => {
    return (
        <div className={"page-title-container"} >
            <h1>{props.title}</h1>
        </div>
    )
}

export { Comp10 }